'use strict';

module.exports = require('./is-implemented')()
	? Object.keys
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/gaearon/p/react-devtools/~/es5-ext/object/keys/index.js
 ** module id = 200
 ** module chunks = 0
 **/